// extracted by mini-css-extract-plugin
export default {"openInFullPageLink":"RhUsrhrgmlYN3ynKpngw","shareLinkButton":"RTofrwDH3DDHxwDBA6HB"};